export enum ProfileTypeIdentifier {
  business = 'BUSINESS',
  private = 'PRIVATE',
}
